module.exports = __webpack_public_path__ + "img/15.37ebd472.jpg";